import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseImageUrl from "@insite/client-framework/Common/Utilities/parseImageUrl";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { FlexItemProps } from "@insite/content-library/Widgets/Brand/FlexItem";
import { FlexWrapContainerProps } from "@insite/content-library/Widgets/Brand/FlexWrapContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import LazyImage from "@insite/mobius/LazyImage";
import { LinkProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css, ThemeProps, withTheme } from "styled-components";

interface SlideModel {
    fields: {
        slideTitle: string;
        image: string;
        heading: string;
    };
}
const enum fields {
    title = "title",
    bottom = "bottom",
    slides = "slides",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.bottom]: string;
        [fields.slides]: SlideModel[];
    };
}

type Props = OwnProps & ThemeProps<BaseTheme> & HasShellContext;

export interface CENPunchOutLandingPageLOGOStyles {
    container?: InjectableCss;
    imageContainer?: FlexWrapContainerProps;
    imageItem?: FlexItemProps;
    link?: LinkProps;
    logoImgwrapper?: InjectableCss;
    title?: InjectableCss;
    imgWrapper?: InjectableCss;
    lazyImage?: InjectableCss;
    bottom?: InjectableCss;
}

export const cenPunchOutLandingPageLOGOStyles: CENPunchOutLandingPageLOGOStyles = {
    bottom: {
        css: css`
            display: flex;
            justify-content: center;
            font-size: 16px;
            font-weight: 600;
            line-height: 32px;
            color: ${getProp("theme.typography.p.color")};
            margin-top: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 16px;
                    `,
                    css``,
                    null,
                    null,
                    null,
                ])}
        `,
    },

    imgWrapper: {
        css: css`
            height: 100%;
        `,
    },
    title: {
        css: css`
            display: flex;
            justify-content: center;
            font-size: 24px;
            font-weight: 600;
            line-height: 32px;
            color: ${getProp("theme.typography.p.color")};
            margin-bottom: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 16px;
                    `,
                    css``,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    logoImgwrapper: {
        css: css`
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-auto-rows: 100px;
            row-gap: 8px;
            column-gap: 128px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        grid-template-columns: repeat(2, 1fr);
                        grid-auto-rows: 100px;
                        column-gap: 0px;
                    `,
                    css``,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    imageContainer: {
        css: css`
            min-height: 131px;
            width: 100%;
            span {
                height: 100%;
                width: 100%;
            }
            div[class^="LazyImageStyle"] {
                width: 100%;
            }
            span[class^="IconWrapper"] {
                width: 100%;
                justify-content: center;
            }
        `,
    },
};

const styles = cenPunchOutLandingPageLOGOStyles;

const CENPunchoutPageLogo: React.FC<Props> = ({ fields }) => {
    if (!fields.slides) {
        return null;
    }
    return (
        <>
            <StyledWrapper {...styles.container}>
                <Typography {...styles.title}>{fields.title}</Typography>
                <StyledWrapper {...styles.logoImgwrapper}>
                    {fields.slides?.map((slides: any) => {
                        return (
                            <>
                                <StyledWrapper>
                                    <StyledWrapper {...styles.imgWrapper}>
                                        <LazyImage
                                            src={parseImageUrl(slides.fields.image).url}
                                            altText={slides.fields.heading}
                                        />
                                    </StyledWrapper>
                                </StyledWrapper>
                            </>
                        );
                    })}
                </StyledWrapper>
                <Typography {...styles.bottom}>{fields.bottom}</Typography>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withIsInShell(withTheme(CENPunchoutPageLogo)),
    definition: {
        group: "Brands",
        icon: "image",
        displayName: "Punchout Logo Section",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
            },
            {
                name: fields.bottom,
                displayName: "Bottom Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
            },

            {
                name: fields.slides,
                editorTemplate: "ListField",
                getDisplay: ({ fields: { slideTitle } }) => slideTitle || "Slide",
                defaultValue: [],
                fieldType: "Contextual",
                fieldDefinitions: [
                    {
                        name: "image",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },
                    {
                        name: "heading",
                        editorTemplate: "TextField",
                        displayName: "Heading",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
